import Logger from 'alife-logger'
import store from '@/store'


if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ARMS_PID) {
  const __bl = Logger.singleton(
    {
      pid: process.env.VUE_APP_ARMS_PID, // 前端监控应用ID
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
      useFmp: true,
      release: process.env.VUE_APP_VERSION, // 版本号
      environment: process.env.VUE_APP_PROD // 环境
    }
    )
  // 禁用API自动上报
  __bl.setConfig({
    disableHook: true
  })

  // 若页面加载初期暂时无法获取用户名，则可设置返回Null，但不要设置返回一个临时用户名。因为SDK发送日志时会再次调用setUsername方法获取用户名，如果之前设置了返回临时用户名，则会一直沿用最初设置的用户名，不再重新获取。
  __bl.setConfig({
    setUsername: function () {
      return store.getters.getUserName || null
    }
  })

  // 忽略指定URL/API/JS错误。符合规则的日志将被忽略且不会被上报，包含子配置项ignoreUrls、ignoreApis、ignoreErrors和ignoreResErrors。
  __bl.setConfig({
    ignore: {
      ignoreApis: [
        function (str) {
          if (/http:\/\/localhost:17521\/socket.io/.test(str)) {
            return true // 不上报
          }
          return false // 上报
        }
      ],
      ignoreErrors: [
        function (str) {
          if (/[naturalWidth] | [n is not defined] | [Network Error]/.test(str)) {
            return true; // 不上报
          }
          return false; // 上报
        },
      ],
    }
  })
  // 自定义字段
}
